import React, { memo, useState } from "react";
import AccessoriesTable from "components/Admin/Tables/AccessoriesTable";
import { makeStyles, AppBar, Tabs, Tab } from "@material-ui/core";
import TabPanel from "components/Admin/TabPanel";
import FiltersTable from "components/Admin/Tables/FiltersTable";
function a11yProps(index: number) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

const AccessoriesWidget: React.FC = () => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          onChange={handleChange}
        >
          <Tab label="Аксесоари" {...a11yProps(0)} />
          <Tab label="Стойности на филтри" {...a11yProps(1)} />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <AccessoriesTable />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <FiltersTable objectType={"accessory"} />
      </TabPanel>
    </div>
  );
};

export default memo(AccessoriesWidget);
